// 상단 탭에 「지금 열린 메뉴」 이름을 띄우기 위한 경로 → 메뉴명 조회 (부수효과 없는 순수 함수).
// 데이터: GET /api/basicinfo/common/menus 의 평면 목록. path 가 있는 행만 화면 메뉴다(null 은 폴더·개발예정).
import { isPathUnder } from './moduleRegistry';

export interface MenuLine {
  path: string;
  name: string;
}

/** 원시 응답 → 화면 메뉴(path·name 이 있는 행)만. 깨진 행은 버린다 */
export function normalizeMenus(raw: unknown): MenuLine[] {
  if (!Array.isArray(raw)) return [];
  const out: MenuLine[] = [];
  for (const row of raw) {
    if (!row || typeof row !== 'object') continue;
    const r = row as Record<string, unknown>;
    const path = typeof r.path === 'string' ? r.path.trim().replace(/\/+$/, '') : '';
    const name = typeof r.name === 'string' ? r.name.trim() : '';
    if (path && path[0] === '/' && name) out.push({ path, name });
  }
  return out;
}

/** 경로에 해당하는 메뉴명 — 상세 경로(/finance/FI-22/is)는 메뉴 경로 접두어로 맞추고 더 긴 쪽이 이긴다. 없으면 null */
export function menuNameForPath(menus: MenuLine[], pathname: string): string | null {
  let hit: MenuLine | null = null;
  for (const m of menus) {
    if (isPathUnder(pathname, m.path) && (!hit || m.path.length > hit.path.length)) hit = m;
  }
  return hit ? hit.name : null;
}

/** 경로에 해당하는 메뉴 한 줄 — menuNameForPath 와 같은 규칙, 경로까지 돌려준다 */
export function menuForPath(menus: MenuLine[], pathname: string): MenuLine | null {
  let hit: MenuLine | null = null;
  for (const m of menus) {
    if (isPathUnder(pathname, m.path) && (!hit || m.path.length > hit.path.length)) hit = m;
  }
  return hit;
}
